export class BomIndentInfo {
    bomId: string;
    count: number;
    product: string;
    bomQuantity: number;
    indentQuantity: number;
    /**
     * 
     * @param bomId
     * @param product
     * @param bomQuantity
     * @param count
     */
    constructor(bomId: string,count: number,bomQuantity: number,product: string,indentQuantity:number) {
        this.bomId = bomId;
        this.count = count;
        this.bomQuantity = bomQuantity;
        this.product = product;
        this.indentQuantity = indentQuantity;
    }
}